import React, { useState } from 'react'

import Relazsizes from 'relazsizes'
import isDOMAvailable from 'utils/isDOMAvailable'

import SectionContainer from 'components/atoms/SectionContainer'
import Col from 'components/atoms/Col'
import Container from 'components/atoms/Container'
import Markdown from 'components/atoms/MarkdownContent'
import Row from 'components/atoms/Row'
import Typography from 'components/atoms/Typography'
import FAQ from 'components/molecules/FAQ'

import config from 'config'
import faqData from './faqData.json'

const { assets_url: assetsUrl } = config
const peluangAssetsPath = `${assetsUrl}/assets/img/peluang`

const PeluangFAQ = () => {
  const initialState = () => faqData.map((faq, idx) => ({
    ...faq,
    active: idx === 0,
    id: idx,
    answer: <Markdown content={faq.answer} className="peluang-faq__answer"/>,
  }))
  const [faqs, setFaqs] = useState(initialState())

  const toggleAnswer = (id) => {
    const newFaqs = faqs.map(faq => (
        faq.id === id ? { ...faq, active: !faq.active } : { ...faq, active: false }
      ),
    )
    setFaqs(newFaqs)
  }

  return (
    <div className="peluang-faq">
      { (isDOMAvailable && window.outerWidth >= 768) ?
        <Relazsizes src={`${peluangAssetsPath}/top-pc.svg`} className="peluang-faq__img-top" /> :
        <Relazsizes src={`${peluangAssetsPath}/top-sp.svg`} className="peluang-faq__img-top" />
      }
      <SectionContainer
        paddingTop={120}
        paddingBottom={120}
        backgroundColor="#1d3f6c"
      >
        <Container>
          <Typography component="h2" variant="title-sm" className="peluang-faq__title">
            Pertanyaan Seputar Cek Peluang SBMPTN
          </Typography>
        </Container>
        <Container mobileFull>
          <Row className="peluang-faq__row">
            <Col md="5">
              <Relazsizes dataSrc={`${peluangAssetsPath}/faq.png`} alt="peluang-faq" className="peluang-faq__img" />
            </Col>
            <Col md="7">
              <div className="peluang-faq__faq">
                {
                  faqs.map(faq => (
                    <FAQ
                      question={faq.question}
                      answer={faq.answer}
                      active={faq.active}
                      key={`peluang-faq-itm-${faq.id}`}
                      onClick={() => toggleAnswer(faq.id)}
                    />
                  ))
                }
              </div>
            </Col>
          </Row>
        </Container>
      </SectionContainer>
      <style jsx>
        {`
          .peluang-faq {
            position: relative;
            :global(&__img-top) {
              position: absolute;
              width: 100%;
              top: -2px;
            }
            :global(&__title) {
              text-align: center;
              color: #fff !important;
            }
            :global(&__row) {
              margin-top: 96px;
            }
            :global(&__img) {
              width: 100%;
              padding: 24px 56px 0 0;
            }
            :global(&__answer) {
              :global(p) {
                margin: 0 !important;
                font-size: 14px !important;
              }
            }
            :global(.faq__question) {
              font-size: 16px !important;
            }
            :global(.faq__answer, .faq__question) {
              padding: 16px;
            }
            @media screen and (max-width: 767px) {
              :global(&__img) {
                display: none;
              }
              :global(&__title) {
                margin-top: 80px !important;
              }
            }
          }
        `}
      </style>
    </div>
  )
}

export default PeluangFAQ
